import Controller from '@philips-emr/tws-core/lib/client';

import { FragmentNames } from '../../codegen';

@Controller({ fragment: FragmentNames.ACCREDITATION_CNES })
class AccreditationCnesController {

}

export default AccreditationCnesController;
